import { createModel } from "hox";
import { IApplySearch, IApplyParams, IApplyDetail, IApplyInsert, IApplyUpdata, IApplyDisable } from "./applyTypes"
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "../../../utils/constants";
import { TablePaginationConfig } from "antd/es/table/interface";
import React, { useState } from "react"
import { filterArrId, Optios, transPgToPagination, findOption } from "../../../utils/utils"
import { IPgProps, ISearchPage } from "../../../types/FmsTypes";
import { PaginationProps } from "antd/es/pagination";
import { globalPrompt } from "../../../components2/YhMessage"
import { applyService } from "./applyService"
import useMdmModel from "../../../model/mdmModel"
import moment, { Moment } from "moment";

export const useApplyModel = createModel(function () {
    const { mdmOrgan } = useMdmModel();

    const initSearchParams: IApplyParams = {}
    const initDataSource: IApplyDetail[] = []
    const initAddParam: IApplyInsert = { enable: true, branch: "main" }
    const initPage: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<IApplyParams>(initSearchParams)
    //列表数据
    const [dataSource, setDataSource] = useState<IApplyDetail[]>(initDataSource);
    //分页参数
    const [page, setPage] = useState<TablePaginationConfig>(initPage);
    //表格选中行key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    ////表格选中行的数据
    const [selectedRow, setSelectedRow] = useState<IApplyDetail[]>([]);
    //新增参数
    const [addParam, setAddParam] = useState<IApplyInsert>(initAddParam);
    const upDataSearchParam = (upDataParam: IApplyParams) => {
        setSearchParam({ ...searchParam, ...upDataParam })
    }
    const resetSearchParam = async () => {
        await setSearchParam(initSearchParams)
        const resetPage = { pageSize: 15, pageNum: 1 }
        await loadData(resetPage, initSearchParams)
    }
    const loadData = async (pages?: ISearchPage, data?: IApplyParams) => {
        const searchParams = data ?? searchParam
        const params = {
            ...searchParams,
            page: {
                pageSize: pages?.pageSize ?? page.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: pages?.pageNum ?? page.current ?? DEFAULT_FIRST_PAGE_NUM
            }
        }
        const { retData } = await applyService.page(params)
        const { records, ...pg } = retData
        setPage(transPgToPagination(pg));
        setDataSource(records)
    }
    const updataAddParam = (updateParam: IApplyInsert) => {
        // console.log(updateParam)
        let newUpdateParam = updateParam
        setAddParam({ ...addParam, ...newUpdateParam })
    }
    const updataEditParam = (updateParam: IApplyDetail) => {
        let newUpdateParam = updateParam
        setSelectedRow([{ ...selectedRow[0], ...newUpdateParam }])
    }
    const insertDetail = async (params: IApplyInsert) => {
        const param = {
            ...addParam,
            sourceApp: "mdm",
            enable: addParam.enable ? 1 : 0,
            appUrl: addParam?.appUrl?.join()
        } as IApplyInsert
        const { retData, retMsg } = await applyService.insert(param)
        globalPrompt("message", { type: "success", text: retMsg })
        return retData
    }
    const updataDetail = async (params: IApplyDetail) => {
        const param = {
            ...selectedRow[0],
            enable: selectedRow[0].enable ? 1 : 0,
            appUrl: selectedRow[0]?.appUrl?.join()
        } as IApplyDetail
        const { retData, retMsg } = await applyService.update(param as IApplyUpdata)
        globalPrompt("message", { type: "success", text: retMsg })
        return retData
    }
    const cutDisabled = async (params: IApplyDetail, checked: boolean) => {
        const param = {
            ...params,
            enable: checked ? 1 : 0,
        }
        const { retData, retMsg } = await applyService.update(param)
        await globalPrompt("message", { type: "success", text: "修改完成" })
        await loadData()
    }
    return {
        searchParam,
        dataSource,
        page,
        selectedRow,
        selectedRowKeys,
        addParam,
        setSearchParam,
        setDataSource,
        setPage,
        setSelectedRowKeys,
        setSelectedRow,
        upDataSearchParam,
        resetSearchParam,
        loadData,
        setAddParam,
        updataAddParam,
        updataEditParam,
        insertDetail,
        updataDetail,
        cutDisabled
    }
});